import { render } from "./milestone-plan-header.vue?vue&type=template&id=22902bbd&ts=true"
import script from "./milestone-plan-header.vue?vue&type=script&lang=ts"
export * from "./milestone-plan-header.vue?vue&type=script&lang=ts"

import "./milestone-plan-header.vue?vue&type=style&index=0&id=22902bbd&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__